import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import FileIcon from '@atlaskit/icon/core/file';
import DocumentsIcon from '@atlaskit/icon/core/files';
import OfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import QuoteIcon from '@atlaskit/icon/core/quotation-mark';

import { EditedDefinitionScope } from '@atlassian/search-ai';

const i18n = defineMessages({
	editDefinitionRestrictedToSpaceOption: {
		id: 'contextual-reading-aids.edit.definition.restricted.to.space.option',
		defaultMessage: 'In this space',
		description: 'Text for space restriction option',
	},
	editDefinitionRestrictedToPageOption: {
		id: 'contextual-reading-aids.edit.definition.restricted.to.page.option',
		defaultMessage: 'On this page',
		description: 'Text for page restriction option',
	},
	editDefinitionRestrictedToBlogpostOption: {
		id: 'contextual-reading-aids.edit.definition.restricted.to.blogpost.option',
		defaultMessage: 'On this blogpost',
		description: 'Text for blogpost restriction option',
	},
	editDefinitionRestrictedToSiteOption: {
		id: 'contextual-reading-aids.edit.definition.restricted.to.site.option',
		defaultMessage: 'On this site',
		description: 'Text for site restriction option',
	},
});

export function useDefinitionRestrictionOptions(contentType?: string) {
	const { formatMessage } = useIntl();

	return useMemo(
		() => [
			{
				label: formatMessage(i18n.editDefinitionRestrictedToSpaceOption),
				value: EditedDefinitionScope.SPACE,
				icon: <DocumentsIcon label="" />,
			},
			contentType === 'blogpost'
				? {
						label: formatMessage(i18n.editDefinitionRestrictedToBlogpostOption),
						value: EditedDefinitionScope.BLOGPOST,
						icon: <QuoteIcon label="" />,
					}
				: {
						label: formatMessage(i18n.editDefinitionRestrictedToPageOption),
						value: EditedDefinitionScope.PAGE,
						icon: <FileIcon label="" />,
					},
			{
				label: formatMessage(i18n.editDefinitionRestrictedToSiteOption),
				value: EditedDefinitionScope.ORGANIZATION,
				icon: <OfficeBuildingIcon label="" />,
			},
		],
		[contentType, formatMessage],
	);
}
